import WC from "../common/WebcomponentCreator"
import FilterFactory from "../common/FilterFactory"
import "../common/multiSelect"
import "../common/ButtonSelectBase"
import "../css/filter.css"
import styles from "styles-to-js-loader/styles"

class FilterBase extends WC {
    DISCLAIMER_ENABLED = true // Set to false to disable
    DISCLAIMER_TEXT = `Flera regioner genomgår byten av vårdinformationssystem, detta påverkar rapportering och datakvalitet.
För närvarande berör detta regionerna Blekinge, Dalarna, Gävleborg, Halland, Norrbotten, Sörmland, Västerbotten, Västernorrland och Örebro.
Data som påverkas är rödmarkerat i tabeller och grafer nedan.`

    constructor(disableDisclaimer = false) {
        const template = document.createElement("form")
        template.setAttribute("id", "filterContainer")
        super(template, { shadowMode: "closed" })
        this.getShadow().appendChild(styles.get())
        this.template = template
        this.selectors = {}
        this.divs = {}
        this.selectorsDataPromises = []
        this.url = ""

        if (this.DISCLAIMER_ENABLED && !disableDisclaimer) {
            this.insertDisclaimer(this.DISCLAIMER_TEXT)
        }
    }
    insertDisclaimer(text) {
        const disclaimer = document.createElement("div")
        disclaimer.classList.add("disclaimer")
        disclaimer.textContent = text
        disclaimer.style.padding = "10px 5px"
        disclaimer.style.fontSize = "14px"
        disclaimer.style.color = "#D32F2F" // EU disability standard compliant red
        disclaimer.style.fontWeight = "bold"
        disclaimer.style.borderBottom = "2px solid #D32F2F" // Line at the bottom only
        disclaimer.style.marginBottom = "10px"
        disclaimer.style.whiteSpace = "pre-line" // Preserve new lines

        // Insert disclaimer before the first selector (top of the filter)
        this.template.prepend(disclaimer)
    }
    //Takes in an array like this:
    /*
    [
        {
            name: "regionSelector",
            divName: "firstDiv",
            data: [{...}],
            header: "Välj nånting",
            events: [
                {
                    name: "change",
                    callback: function(){}
                }
            ],
            attributes:{
                disabled: true
            }

        }
    ]
    */
    addSelectors(selectors) {
        for (var i = 0; i < selectors.length; i++) {
            var selector = selectors[i]
            var temp
            if (selector.multiple) {
                temp = document.createElement("multi-select")
            } else if (selector.button) {
                temp = document.createElement("button-select")
            } else temp = document.createElement("select")
            //Add div if it doesnt exist
            if (!this.divs[selector.divName] && !selector.button)
                this.addDiv(selector.divName)
            //If attributes exists, add them
            if (selector.attributes) {
                Object.keys(selector.attributes).forEach((attrKey) => {
                    //temp[attrKey] = selector.attributes[attrKey];
                    if (attrKey === "disabled") {
                        if (
                            typeof selector.attributes.disabled === "function"
                        ) {
                            temp.setAttribute(
                                attrKey,
                                selector.attributes.disabled()
                            )
                        } else {
                            temp.setAttribute(
                                attrKey,
                                selector.attributes[attrKey]
                            )
                        }
                    }
                    temp.setAttribute(attrKey, selector.attributes[attrKey])
                })
                if (!selector.attributes.id) {
                    temp.id = selector.name
                }
            } else {
                temp.id = selector.name
            }
            //If events exist, add them
            if (selector.events) {
                selector.events.forEach((e) => {
                    if (e.name && e.callback)
                        temp.addEventListener(e.name, e.callback)
                    else
                        console.error(
                            "Filter: Selector event needs name and callback",
                            e,
                            selector.name
                        )
                })
            }
            var addToGroup = false
            var group
            //Add header to select
            if (selector.header) {
                addToGroup = true
                var label = document.createElement("label")
                label.setAttribute("for", temp.id)
                label.innerHTML = selector.header
                group = document.createElement("div")
                group.setAttribute("class", "group")
                group.appendChild(label)
            }
            //add to div
            if (this.divs[selector.divName] && !selector.button)
                if (!addToGroup) this.divs[selector.divName].appendChild(temp)
                else {
                    group.appendChild(temp)
                    this.divs[selector.divName].appendChild(group)
                }
            else this.getShadow().insertBefore(temp, this.template)
            selector.selectorObj = temp
            this.selectors[selector.name] = selector
            //Add initial data if exist
            if (selector.data) {
                if (selector.button)
                    this.addDataToButtonSelect(selector.name, selector.data)
                else this.addDataToSelect(selector.name, selector.data)
            }
            if (selector.header && selector.button) {
                selector.selectorObj.addTitle(selector.header)
            }
        }
    }
    addDiv(name) {
        var div = document.createElement("div")
        div.setAttribute("id", name)
        this.template.appendChild(div)
        this.divs[name] = div
    }
    /**
     * data format:
     * [{value: -1, label: "Alla regioner"}]
     * OR
     * ["Alla regioner"]
     */
    addDataToSelect(name, data = []) {
        let currSelect = this.selectors[name].selectorObj

        if (this.selectors[name].multiple) {
            currSelect.data = data
        } else {
            this.removeOptionsFromSelect(name)
            //Create options and add to select

            for (var i = 0; i < data.length; i++) {
                var o = document.createElement("option")
                if (
                    typeof data[i] === "string" ||
                    typeof data[i] === "number"
                ) {
                    o.innerHTML = data[i]
                    o.value = data[i]
                    currSelect.appendChild(o)
                } else {
                    if (
                        (data[i] && data[i].name && data[i].value) ||
                        (data[i] && data[i].name && data[i].value === 0)
                    ) {
                        o.innerHTML = data[i].name
                        o.value = data[i].value
                        currSelect.appendChild(o)
                    }
                }
            }
        }
        this.selectors[name].data = data
        //If startDown, select last element
        if (this.selectors[name].startDown) {
            var lastOption = currSelect.options[currSelect.options.length - 1]
            lastOption.selected = true
        }
    }

    addDataToButtonSelect(name, data) {
        const currSelect = this.selectors[name]
        const options = []

        for (let i = 0; i < data.length; i++) {
            const option = {
                text: data[i].name,
                value: data[i].value,
                id: `${i}${data[i].value}btn`
            }

            // If a callback is provided, attach it later
            if (data[i].callback) {
                option.callback = data[i].callback
            }

            options.push(option)
        }

        // Set up buttons in the selector object
        currSelect.selectorObj.setUpButtons(options)

        // Attach event listeners for options with callbacks
        options.forEach((option) => {
            if (option.callback) {
                const button =
                    currSelect.selectorObj._shadow?.getElementById(option.id) ||
                    document.getElementById(option.id)
                if (button) {
                    button.addEventListener("click", option.callback)
                } else {
                    console.warn(`Button with ID "${option.id}" not found`)
                }
            }
        })
    }

    removeOptionsFromSelect(name) {
        var currSelect = this.selectors[name].selectorObj
        if (this.selectors[name].multiple) {
            currSelect.data = []
            return
        }
        //Remove all options
        var length = currSelect.options.length
        for (let i = length - 1; i >= 0; i--) {
            currSelect.options[i] = null
        }
    }
    updateSelect(name, newData) {
        var select = this.selectors[name]
        if (!select) return
        if (select.button) {
        }

        var selectedIndex = select.selectorObj.selectedIndex
        var oldOptions
        if (!select.multiple)
            oldOptions = this.HTMLOptionsCollectionToArray(select.selectorObj)
        this.addDataToSelect(name, newData)
        var updatedSelect = this.selectors[name]
        if (selectedIndex === undefined || selectedIndex === -1) return
        if (select.multiple) {
            return
        }
        //Regular single select
        var oldSelectedValue = oldOptions[selectedIndex].value
        for (var j = 0; j < updatedSelect.selectorObj.options.length; j++) {
            if (
                updatedSelect.selectorObj.options[j].value === oldSelectedValue
            ) {
                updatedSelect.selectorObj.value = oldSelectedValue
                break
            }
        }
    }
    getSelectValue(name) {
        var val = this.selectors[name].selectorObj.value
        if (Array.isArray(val)) {
            var newVal = []
            for (let i = 0; i < val.length; i++) {
                if (val[i].toString() !== "-1")
                    if (this.selectors[name].multiple)
                        newVal.push(val[i].toString())
                    else newVal.push(val[i])
            }
            val = newVal
        }
        return val
    }
    getSelectText(name) {
        var selectedIndex = this.selectors[name].selectorObj.selectedIndex
        if (Array.isArray(selectedIndex)) {
            var res = []
            for (var i = 0; i < selectedIndex.length; i++) {
                res.push(
                    this.selectors[name].selectorObj.options[selectedIndex[i]]
                        .innerHTML
                )
            }

            if (res.length > 0) return res
            else return this.selectors[name].selectorObj.defaultLabel
        }
        return this.selectors[name].selectorObj.options[
            this.selectors[name].selectorObj.selectedIndex
        ].text
    }
    getSelector(name) {
        const selector = this.selectors[name]
        if (!selector) return null
        return selector.selectorObj
    }
    addSubmitButton(options) {
        var submit = new FilterFactory("submit", options.text, {})
        submit.setAttribute("id", "submitButton")

        if (!this.divs[options.divName]) this.addDiv(options.divName)
        this.divs[options.divName].appendChild(submit)
        var condition = options.condition ? options.condition() : true
        if (options.submitName && options.valueCallback && options.textCallback)
            this.template.addEventListener("submit", (e) => {
                e.preventDefault()
                if (condition) {
                    this.dispatchSubmitEvent(
                        options.submitName,
                        options.valueCallback,
                        options.textCallback
                    )
                }
            })
        this.submitButton = submit
    }

    //The event that dispatches when we want to update graph
    dispatchSubmitEvent(name, valueCallback, textCallback) {
        this.dispatchEvent(
            new CustomEvent(name, {
                bubbles: true,
                composed: true,
                detail: { values: valueCallback(), text: textCallback() }
            })
        )
    }

    addClearFilterButton(options) {
        var clear = document.createElement("input")
        clear.setAttribute("type", "reset")
        clear.setAttribute("id", "clearButton")
        clear.value = options.text
        if (!this.divs[options.divName]) this.addDiv(options.divName)
        this.divs[options.divName].appendChild(clear)
        this.template.addEventListener("reset", (e) => {
            e.preventDefault()
            var selectorArr = Object.values(this.selectors)
            for (var i = 0; i < selectorArr.length; i++) {
                var currSelect = selectorArr[i]
                if (!currSelect.button) {
                    // Check if the select element has any options
                    if (currSelect.multiple) {
                        currSelect.selectorObj.reset()
                        if (
                            currSelect.attributes &&
                            currSelect.attributes.disabled
                        )
                            currSelect.selectorObj.setAttribute(
                                "disabled",
                                true
                            )
                    } else {
                        if (currSelect.startDown)
                            currSelect.selectorObj.options[
                                currSelect.selectorObj.options.length - 1
                            ].selected = true
                        else currSelect.selectorObj.options[0].selected = true
                        if (currSelect.attributes) {
                            //If disabled is a function, take return value to set disabled

                            if (
                                typeof currSelect.attributes.disabled ===
                                "function"
                            ) {
                                if (currSelect.attributes.disabled()) {
                                    currSelect.selectorObj.setAttribute(
                                        "disabled",
                                        true
                                    )
                                } else {
                                    currSelect.selectorObj.removeAttribute(
                                        "disabled"
                                    )
                                }
                            } else if (currSelect.attributes.disabled) {
                                currSelect.selectorObj.setAttribute(
                                    "disabled",
                                    true
                                )
                            }
                        }

                        currSelect.selectorObj.dispatchEvent(
                            new Event("change")
                        )
                    }
                }
            }
        })
    }
    addSearchRequestListener(
        requestName = "",
        callback = this.setRegionSelectSelectedOption.bind(this)
    ) {
        document.addEventListener(requestName, (e) => {
            callback(e.detail)
        })
    }
    setOptionValue(value, optionText) {
        if (optionText.toLowerCase().includes("region")) {
            return value
        } else {
            if (!value.includes("Region")) {
                return value
            } else {
                const modifiedValue = value.split(" ")[1]
                value = modifiedValue.endsWith("s")
                    ? modifiedValue.slice(0, -1)
                    : modifiedValue
                return value
            }
        }
    }
    setRegionSelectSelectedOption(value = "") {
        var options = this.selectors["regionSelect"].selectorObj.options
        var found = false
        if (
            (value.indexOf("Alla") === 0 ||
                value.toLowerCase().includes("sjukvårdsregion")) &&
            this.selectors["regionSelect"].multiple
        ) {
            this.selectors["regionSelect"].selectorObj.reset()
            found = true
            this.selectors["unitSelect"] &&
                this.selectors["unitSelect"].selectorObj.setAttribute(
                    "disabled",
                    true
                )
        } else {
            for (var i = 0; i < options.length; i++) {
                value = this.setOptionValue(value, options[i].innerHTML)
                if (options[i].innerHTML === value) {
                    if (this.selectors["regionSelect"].multiple) {
                        this.selectors["regionSelect"].selectorObj.value = [
                            options[i].value
                        ]
                        if (
                            this.selectors["unitSelect"] &&
                            this.selectors["unitSelect"].multiple
                        ) {
                            this.selectors["unitSelect"].selectorObj.reset()
                        } else if (this.selectors["unitSelect"]) {
                            this.selectors["unitSelect"].selectorObj.value = -1
                        }
                    } else {
                        options[i].selected = true
                        var event = new Event("change")
                        this.selectors[
                            "regionSelect"
                        ].selectorObj.dispatchEvent(event)
                    }
                    found = true
                }
            }
        }
        if (!found && this.selectors["unitSelect"]) {
            options = this.selectors["unitSelect"].selectorObj.options
            if (
                value.indexOf("Alla") === 0 &&
                this.selectors["unitSelect"].multiple
            ) {
                this.selectors["unitSelect"].selectorObj.reset()
                found = true
            } else {
                for (var i = 0; i < options.length; i++) {
                    if (options[i].innerHTML === value) {
                        if (this.selectors["unitSelect"].multiple)
                            this.selectors["unitSelect"].selectorObj.value = [
                                options[i].value
                            ]
                        else {
                            options[i].selected = true
                            var event = new Event("change")
                            this.selectors[
                                "unitSelect"
                            ].selectorObj.dispatchEvent(event)
                        }
                        found = true
                    }
                }
            }
        }
        if (found) {
            this.submitButton && this.submitButton.click()
        }
    }

    selectOptionByValue(selectName, value) {
        const selectElement = this.getSelector(selectName)
        for (let i = 0; i < selectElement.options.length; i++) {
            if (
                selectElement.options[i].value.toString() === value.toString()
            ) {
                selectElement.selectedIndex = i
                selectElement.options[i].selected = true
                break
            }
        }
    }

    HTMLOptionsCollectionToArray(selectObj) {
        var vals = []
        for (var i = 0, n = selectObj.options.length; i < n; i++) {
            // looping over the options
            if (selectObj.options[i]) vals.push(selectObj.options[i]) // a bit of testing never hurts
        }
        return vals
    }
}

export default FilterBase
